import { ActionRecord, MetaEntry } from '../../lib/types'

export default function filterReviews(reviews: ActionRecord[], meta: MetaEntry[]): ActionRecord[] {
    return reviews.filter((r) => {
        const reviewTime = new Date(r.actionTime)
        const extra = JSON.parse(r.extras!)
        return !meta
            .filter((m) => m.objId === Number(extra.objId))
            .some((m) => new Date(m.reviewFinished) > reviewTime)
    })
}

export function filterArbitrationReviews(reviews: ActionRecord[], meta: MetaEntry[]): ActionRecord[] {
    return reviews.filter((r) => {
        const reviewTime = new Date(r.actionTime).toISOString().slice(0,10)
        const extra = JSON.parse(r.extras!)
        return meta
            .filter((m) => m.objId === Number(extra.objId))
            .some((m) => {
                const finishedTime = new Date(m.reviewFinished).toISOString().slice(0,10)
                return reviewTime >= finishedTime
            })
    })
}
